type HideProps = {
  visible?: any /* eslint-disable-line @typescript-eslint/no-explicit-any */
  children: React.ReactNode
}

export function Hide({ visible, children }: HideProps): JSX.Element | null {
  return visible ? (children as JSX.Element) : null
}
